// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-title[data-v-fc4501c4]{font-family:mariupol-medium,serif;font-weight:500;font-size:32px;line-height:40px}@media(max-width:600px){.dialog-title[data-v-fc4501c4]{font-size:24px;line-height:32px}}.dialog-text[data-v-fc4501c4]{font-weight:400;font-size:16px;line-height:24px;color:rgba(7,6,0,.7)}", ""]);
// Exports
module.exports = exports;
